import CheckboxDropdown from "components/checkbox-dropdown/CheckboxDropdown";
import ColorCheckbox from "../../../color-checkbox/ColorCheckbox";
import { useShowCancelledSessions } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/ShowCancelledSessionContext";
import messages from "messages";
import { AmplitudePageName, track } from "utils/amplitude";

interface CancelledSessionsToggleProps {
  analyticsPageName: AmplitudePageName;
}

const CancelledSessionsToggle = ({
  analyticsPageName,
}: CancelledSessionsToggleProps) => {
  const { showCancelledSessions, setShowCancelledSessions } =
    useShowCancelledSessions();

  return (
    <CheckboxDropdown
      Label={messages.cancelledSessions}
      onClick={() => {
        track(analyticsPageName, "cancelled-sessions-toggle", "click");
        setShowCancelledSessions(!showCancelledSessions);
      }}
      Checkbox={
        <ColorCheckbox
          color={showCancelledSessions ? "var(--error-red)" : "none"}
          backgroundColor={
            showCancelledSessions ? "var(--background-orange)" : "none"
          }
          stroke={
            showCancelledSessions ? "var(--background-orange)" : "var(--gray02)"
          }
        />
      }
    />
  );
};

export default CancelledSessionsToggle;
